import SuccessScreen from './SuccessScreen';

import { env } from '@/utils/env';

const ExtensionSuccessScreen = () => <SuccessScreen appLink={`${env.cabinetUrl}/h/to-chrome`} />;

export default ExtensionSuccessScreen;
